import React from "react";
import { Link } from "react-router-dom";

export const Container = ({ children, className = "" }) => (
  <div className={`container-bc ${className}`}>{children}</div>
);

export const Section = ({ children, sunk = false, className = "", id }) => (
  <section id={id} className={`section ${sunk ? "bg-surface-sunk" : "bg-surface"} ${className}`}>
    <Container>{children}</Container>
  </section>
);

export const Eyebrow = ({ children }) => <div className="eyebrow">{children}</div>;

// Numbered rule-and-label section opener (layout signature #2)
export const RuleLabel = ({ n, label }) => (
  <div className="reveal-on-scroll">
    <div className="h-px w-full bg-line" />
    <div className="eyebrow mt-4">{n} — {label}</div>
  </div>
);

export const SectionHead = ({ n, label, title, intro, className = "" }) => (
  <div className={`max-w-prose ${className}`}>
    {(n || label) && <div className="h-px w-full bg-line mb-4" />}
    {(n || label) && <div className="eyebrow mb-5">{n ? `${n} \u2014 ` : ""}{label}</div>}
    {title && <h2 className="text-3xl md:text-4xl tracking-tight text-ink-950">{title}</h2>}
    {intro && <p className="mt-4 text-lg text-ink-600">{intro}</p>}
  </div>
);

export const Button = ({ to, href, variant = "primary", size = "md", children, className = "", ...rest }) => {
  const cls = `btn-${variant} btn-${size} ${className}`;
  if (to) return <Link to={to} className={cls} {...rest}>{children}</Link>;
  if (href) return <a href={href} className={cls} {...rest}>{children}</a>;
  return <button className={cls} {...rest}>{children}</button>;
};

export const Badge = ({ children }) => <span className="badge">{children}</span>;

export const StatusDot = ({ label = "All systems operational", tone = "positive" }) => (
  <span className="inline-flex items-center gap-2 font-mono text-2xs text-ink-600">
    <span className={`inline-block h-1.5 w-1.5 rounded-full ${tone === "positive" ? "bg-positive" : "bg-signal"}`} />
    {label}
  </span>
);

export const Callout = ({ tone = "note", title, children }) => (
  <aside className={`rounded border-l-2 ${tone === "warning" ? "border-signal bg-surface-sunk" : "border-brand-600 bg-brand-050"} p-4 my-6`}>
    {title && <div className="font-medium text-ink-950 mb-1">{title}</div>}
    <div className="text-ink-600 text-sm">{children}</div>
  </aside>
);

export const Breadcrumb = ({ items }) => (
  <nav aria-label="Breadcrumb" className="font-mono text-2xs text-ink-400">
    <ol className="flex flex-wrap items-center gap-2">
      {items.map((c, i) => (
        <li key={i} className="flex items-center gap-2">
          {i > 0 && <span className="text-ink-200">/</span>}
          {c.path ? <Link to={c.path} className="hover:text-ink-600">{c.name}</Link> : <span className="text-ink-600">{c.name}</span>}
        </li>
      ))}
    </ol>
  </nav>
);

export const Spinner = () => (
  <div className="flex items-center justify-center py-24 text-ink-400 font-mono text-2xs uppercase tracking-eyebrow">Loading…</div>
);
